import { render, staticRenderFns } from "./Damages.vue?vue&type=template&id=04b1a672&scoped=true"
import script from "./Damages.vue?vue&type=script&lang=ts"
export * from "./Damages.vue?vue&type=script&lang=ts"
import style0 from "./Damages.vue?vue&type=style&index=0&id=04b1a672&prod&lang=scss&scoped=true"
import style1 from "./Damages.vue?vue&type=style&index=1&id=04b1a672&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b1a672",
  null
  
)

export default component.exports